var map = {
	"./RFM.svg": "CcIr",
	"./active.svg": "MWzP",
	"./admin-manage.svg": "zgGv",
	"./applyPresident.svg": "rxmI",
	"./arriver_news.svg": "zs+H",
	"./base_manage.svg": "g4lb",
	"./buyCardRecord.svg": "vAPU",
	"./buyCardUser.svg": "aLGW",
	"./cardData.svg": "oNfL",
	"./coupon.svg": "9j5Z",
	"./custom.svg": "Likm",
	"./data.svg": "RUrO",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./gift.svg": "UndF",
	"./giftCard.svg": "ssRb",
	"./giftCards.svg": "JX/W",
	"./goodData.svg": "1j2z",
	"./goods_data.svg": "cEEy",
	"./grant.svg": "4Ssl",
	"./home.svg": "U9Ws",
	"./importOrder.svg": "d4t/",
	"./index_search.svg": "+vtg",
	"./inspection.svg": "w/1l",
	"./live.svg": "ZkmS",
	"./live2.svg": "9qEH",
	"./login-mall.svg": "xzZT",
	"./manage_user.svg": "XKvw",
	"./manager.svg": "xO8E",
	"./marker.svg": "0+/s",
	"./notice.svg": "MqGM",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./orderCHD.svg": "B+k9",
	"./orderSurplus.svg": "UhDG",
	"./password.svg": "QjmH",
	"./popup.svg": "CpfF",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./saveData.svg": "gBcG",
	"./sku.svg": "9Ro6",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./stamps-list.svg": "aS7N",
	"./stamps.svg": "xKTT",
	"./star.svg": "60zo",
	"./status-chd.svg": "z/7b",
	"./status-money.svg": "K6oD",
	"./status-user.svg": "jxuZ",
	"./table.svg": "oSYw",
	"./talk-category.svg": "wZu3",
	"./talk-expert-type.svg": "dAEJ",
	"./talk-expert.svg": "rUZa",
	"./talk-image.svg": "1fkq",
	"./talk-message.svg": "dtQh",
	"./talk-notice.svg": "MV9u",
	"./talk-video.svg": "z4kU",
	"./talk.svg": "MH3N",
	"./topic.svg": "rNYf",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./wdt.svg": "Oflp",
	"./wishIcon.svg": "4VWs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 111